<template>
  <div class="HistoryTable">
    <Commontable @onRowClick="onRowClick" @operation="operation" width="1000px" colnum=7 @handlePageIndexChange="handlePageIndexChange" :tableData="TableData" :headerData="headerData" height="100%">
    </Commontable>
    <div class="pagination" v-if="total > 10">
      <Pagination type="allColor"  @handleCurrentChange="handlePageIndexChange" @handleSizeChange="handleSizeChange"  :total="total"></Pagination>
    </div>
  </div>
</template>

<script>
import Commontable from '../../../../../../../../components/common-table.vue'
import Pagination from '../../../../../../../../components/pagination.vue'
export default {
  components: { Commontable , Pagination},
  props: {
    TableData: {
      type: Array
    },
    headerData: {
      type: Array
    },
     total: {
      type: Number
    },
  },
  data() {
    return {
    }
  },
  created() { },
  mounted() {

  },
  activated() { },
  updated() { },
  methods: {
    // 选中行
    onRowClick(val) {
      this.$emit("onRowClick", val)
    },
    // 操作事件
    operation() {
      this.$emit('operation')
    },
     handlePageIndexChange(pageIndex) { 
      this.$emit('handlePageIndexChange', pageIndex)
    },
    handleSizeChange(PageSize) {
      this.$emit('handleSizeChange', PageSize)
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
</style>